import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type CheckPartnerOperationByYearProps = {
  societyId: string;
  partnerId: string;
  date: Date;
  type: string;
  dateMatchLevel: string;
};

export const checkPartnerOperationByYearAndType =
  ({
    societyId,
    partnerId,
    date,
    type,
    dateMatchLevel,
  }: CheckPartnerOperationByYearProps) =>
  async (dispatch: Dispatch) => {
    const query = {
      params: { societyId, partnerId, date, type, dateMatchLevel },
    };

    try {
      const { data } = await axiosV2.get('/partners/operationDateType', query);

      const decodedData = await decryptResponse(data);
      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
